import { render, staticRenderFns } from "./ContextMenuShortcutKeys.vue?vue&type=template&id=9b6a32f6&"
import script from "./ContextMenuShortcutKeys.vue?vue&type=script&lang=js&"
export * from "./ContextMenuShortcutKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports